import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

import { BuyerService } from 'app/buyer/_services/buyer.service';
import { BuyerPurchaseService } from '../../comprar.service';

import { ImageDisplayService } from 'app/_componentes/image-display/image-display.service';
import { NotificationService } from 'app/_services/notification.service';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { Comentario } from 'app/buyer/_models/comentario';
import { CotacaoSelecionada } from '../../_models/cotacaoSelecionada';
import { Globals } from 'app/_models/globals';
import { Item } from '../../_models/item';
import { PurchaseAreaHeader } from '../../_models/purchaseAreaHeader';
import { SweetAlertParams } from 'app/_models/notificationParams.model';
import { VerMaisDetalhesModalResponseEnum } from '../../_models/modalEnum';
import { SuporteCotacaoPeca } from 'app/support/_models/suporteCotacao';
import { BuyerEditarPartTypeCotacaoComponent } from '../editar-part-type-cotacao.component';
import { UserService } from 'app/_services/user.service';

declare const $: any;
declare const isEmpty: any;
declare const toBase64: any;

@Component({
    selector: 'app-ver-mais-detalhes-modal', templateUrl: 'ver-mais-detalhes-modal.component.html', styleUrls: ['ver-mais-detalhes-modal.component.scss'],
    standalone: false
})
export class BuyerComprarVerMaisDetalhesModalComponent
{
    @Input() purchaseAreaBaseData: PurchaseAreaHeader;
    @Input() cotacaoSelecionada: CotacaoSelecionada;
    @Input() modal_visivel: any;
    @Output() fechar = new EventEmitter<any>();
    @ViewChild(BuyerEditarPartTypeCotacaoComponent) public editPartTypeQuotationModal: BuyerEditarPartTypeCotacaoComponent;
    @ViewChild('templateMaisDetalhes') templateMaisDetalhes: TemplateRef<any>;

    overlapModal: boolean = false;

    areaComprarComentarios: Comentario[];
    loading_adicionar_foto: boolean = false;
    maxUploadImages: number = 15;
    modalRef: BsModalRef;
    novo_comentario: string = '';
    pecaSelecionada: SuporteCotacaoPeca;
    status: VerMaisDetalhesModalResponseEnum = VerMaisDetalhesModalResponseEnum.somenteFechar;
    image;

    constructor(
        public userService: UserService,
        private buyerPurchaseService: BuyerPurchaseService,
        private buyerService: BuyerService,
        private notificationService: NotificationService,
        private globals: Globals,
        private modalService: BsModalService,
        private imageDisplayService: ImageDisplayService) {
        this.maxUploadImages = this.buyerService.maxUploadImages;
    }

    adicionarFoto(foto, fileName) {
        this.cotacaoSelecionada.fotos.push({ file: foto, filename: fileName });
    }

    excluirFoto(file) {
        this.loading_adicionar_foto = true;

        this.cotacaoSelecionada.fotos = this.cotacaoSelecionada.fotos.filter(f => f.file !== file);

        this.buyerPurchaseService.deletePhoto(file).subscribe(
            () => this.loading_adicionar_foto = false,
            error => {
                console.log(error);
                this.loading_adicionar_foto = false;
            });
    }

    fecharModal() {
        this.modalRef.hide();
        this.fechar.emit({ status: this.status, pecaSelecionada: this.pecaSelecionada });
    }

    getComments() {
        this.buyerPurchaseService.getComments(this.cotacaoSelecionada.transaction_id).subscribe({
            next: (response: ApiResponseModel<{ comments: Comentario[] }>) => {
                this.areaComprarComentarios = response.result.comments;
                this.novo_comentario = "";
                this.modal_visivel.comentarios = true;
            },
            error: (error: any) => console.log(error)
        })
    }

    inicializar() {
        let options: ModalOptions = { backdrop: 'static', class: 'gray modal-lg', keyboard: false };
        this.status = VerMaisDetalhesModalResponseEnum.somenteFechar;
        this.modalRef = this.modalService.show(this.templateMaisDetalhes, options);

        if (this.modal_visivel.comentarios)
            this.getComments();
    }

    modal_comentarios_abrir() {
        if(this.areaComprarComentarios) {
            this.novo_comentario = "";
            this.modal_visivel.comentarios = true;
            return
        }

        this.getComments();
    }

    modal_comentarios_fechar() {
        this.novo_comentario = "";
        this.modal_visivel.comentarios = false;
    }

    modal_comentarios_salvar() {
        let texto = this.novo_comentario;

        if (!texto || texto.trim().length === 0)
            return;

        const status_id = 0;
        const abrev = this.globals.translate(`geral.fase-cotacao.abreviacao.${status_id}`);
        const comentario = `${abrev} - ${texto}`;

        var novoComentario: Comentario = { quotation_id: this.cotacaoSelecionada.id, data: new Date(), comentario, usuario: { userCompanyId: this.userService.user().user_company_id, nome: this.userService.user().name } };

        if (!this.areaComprarComentarios)
            this.areaComprarComentarios = [];

        this.areaComprarComentarios.unshift(novoComentario);

        this.novo_comentario = "";

        this.buyerPurchaseService.addComment(novoComentario).subscribe();
    }

    modal_editar_peca_abrir($event, peca: Item) {
        $event.stopPropagation();

        if (!this.userService.user())
            return;

        this.overlapModal = true;
        this.pecaSelecionada = { allows_used: peca.allows_used, item_id: peca.id, codigo: peca.code, nome: peca.name, codigo_nome: peca.nameWithCode, quantidade: peca.quantity, part_type: peca.part_type, is_bo: false };
        this.modal_visivel.editar_peca = true;
    }

    modal_editar_peca_fechar($event) {
        this.modal_visivel.editar_peca = false;
        this.overlapModal = false;
        this.status = $event.atualizar ? VerMaisDetalhesModalResponseEnum.atualizarRespostas : VerMaisDetalhesModalResponseEnum.somenteFechar;

        setTimeout(() => {
            if ($event.atualizar) {
                var peca = this.cotacaoSelecionada.itens.find(p => p.id === this.pecaSelecionada.item_id);

                if (!isEmpty(peca)) {
                    peca.code = this.pecaSelecionada.codigo;
                    peca.nameWithCode = this.pecaSelecionada.codigo_nome;
                    peca.quantity = this.pecaSelecionada.quantidade;
                    peca.allows_used = this.pecaSelecionada.allows_used;
                    peca.part_type = this.pecaSelecionada.part_type;
                }

                this.fechar.emit({ status: this.status, pecaSelecionada: this.pecaSelecionada });
            }
        }, 200);
    }

    modal_editar_peca_remover($event, peca: Item, indice) {
        $event.stopPropagation();

        let confirm = this.globals.translate('buyer.cotacao.area-comprar.modal-mais-detalhes.remover-peca.titulo').replace('{0}', peca.nameWithCode);

        const params: SweetAlertParams = {
            title: confirm,
            notTranslateTitle: true,
            confirmButtonText: 'elemento.generico-botao.remover'
        }

        this.notificationService.showConfirm(params).then((result) => {
            if (result.isConfirmed)
                this.modal_editar_peca_remover_execucao(peca, indice, 0);
        });
    }

    modal_editar_peca_remover_execucao(peca: Item, indice: number, nAttempts: number) {
        this.buyerPurchaseService.deletePart(this.cotacaoSelecionada.id, peca.id).subscribe({
            next: async (response: ApiResponseModel<boolean>) => {
                if (response && response.success && response.result) {
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.cotacao.area-comprar.modal-mais-detalhes.remover-peca.mensagens.sucesso.corpo'));
                    this.status = VerMaisDetalhesModalResponseEnum.listarRespostas;

                    this.cotacaoSelecionada.itens.splice(indice, 1);
                }
                else
                    await this.notificationService.showWarning('buyer.cotacao.area-comprar.modal-mais-detalhes.remover-peca.mensagens.erro.corpo', 'buyer.cotacao.area-comprar.modal-mais-detalhes.remover-peca.mensagens.erro.titulo');
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.cotacao.area-comprar.modal-mais-detalhes.remover-peca.mensagens.erro.corpo'));
                    return;
                }

                this.modal_editar_peca_remover_execucao(peca, indice, ++nAttempts);
            }
        });
    }

    openEditPartTypeQuotationModal() {
        this.overlapModal = true;
        this.editPartTypeQuotationModal.open();
    }

    onCloseEditPartTypeQuotationModal() {
        this.overlapModal = false;
    }

    updateQuotation() {
        this.status = VerMaisDetalhesModalResponseEnum.listarRespostas;

        this.fechar.emit({ status: this.status });
    }

    async uploadImages() {
        var files = (<any>document.getElementById('novaFoto')).files;

        if(!await this.buyerService.validateUploadImage(files, this.cotacaoSelecionada.fotos)) {
            $('#novaFoto').val('');
            return;
        }

        var totalFiles = files.length;

        this.loading_adicionar_foto = true;

        for (let i = 0; i < totalFiles; i++) {
            let file = (<any>document.getElementById('novaFoto')).files[i];
            let b64fileOriginal = (await toBase64(file));
            let b64fileToUpload = b64fileOriginal.indexOf(',') > -1 ? b64fileOriginal.split(',')[1] : b64fileOriginal;

            this.buyerPurchaseService.uploadQuotationImage(this.cotacaoSelecionada.id, b64fileToUpload, file.name).subscribe({
                next: (response: ApiResponseModel<boolean>) => {
                    if (response.success && response.result) {
                        this.adicionarFoto(b64fileOriginal, file.name);
                    }

                    this.loading_adicionar_foto = false;
                },
                error: () => {
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.cotacao.area-comprar.modal-mais-detalhes.upload-imagem.mensagens.erro'));
                    this.loading_adicionar_foto = false;
                }
            });
        }

        $('#novaFoto').val('');
    }

    zoomImage(imageSrc) {
        this.imageDisplayService.setImage(imageSrc);
    }
}
